import { render, staticRenderFns } from "./login_bottom.vue?vue&type=template&id=4acaac1f&scoped=true"
import script from "./login_bottom.vue?vue&type=script&lang=js"
export * from "./login_bottom.vue?vue&type=script&lang=js"
import style0 from "./login_bottom.vue?vue&type=style&index=0&id=4acaac1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acaac1f",
  null
  
)

export default component.exports